var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.headerLogoUrl,"width":_vm.logoWidth,"height":_vm.logoHeight,"max-width":_vm.logoWidth,"max-height":_vm.logoHeight,"contain":true}})}
var staticRenderFns = []

export { render, staticRenderFns }